import { variables } from "../../styles";

const { appToolbarMinHeight, actionBarMinHeight } = variables;

export default (theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    content: {
        height: "100%",
    },
    main: {
        flexGrow: 1,
        overflow: "auto",
    },
    // substract header and footer to make content static
    contentStaticWrp: {
        height: `calc(100% - ${appToolbarMinHeight + actionBarMinHeight}px)`,
    },
    contentScrollableWrp: {
        height: "100%",
    },
    toolbar: {
        color: theme.palette.common.white,
        minHeight: appToolbarMinHeight,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        margin: `0 ${theme.spacing(2)}`,
    },
    logoPadding: {
        paddingLeft: "1rem",
    },
});
